<template>
	<header v-if="show" class="header-wrap">
		<div class="header">
			<div>
				<div class="fl">
					<a href="/aq/homePage" class="logo cursor-pointer">
						<img :src="require(`../../../../static/imgs/exhibition/logo.png`)" width="170">
					</a>
				</div>
				<div class="right">
					<!-- 时区 -->
					<time-zone />
					<!-- 语言选项 -->
					<lang class="container-lang" />
					<el-divider direction="vertical" />
					<!-- 消息通知 -->
					<span class="notify" @click="jump('/aq/messageCenter')">
						<i class="iconfont-new" style="margin-right: 5px;">&#xe70c;</i>
						<span class="text">{{ $t('messageCenter.title') }} {{ noReadMessageCount > 0 ?
							`(${noReadMessageCount})` : '' }}</span>
						<span v-if="noReadMessageCount > 0" class="notification-dot" />
					</span>
					<!--帮助中心下期迭代-->
					<span class="account" @mouseover="mouseoverFunc" @mouseout="mouseoutFunc">
						<i class="iconfont-new" style="margin-right: 5px;">&#xe6be;</i>
						<span class="text" @click="jump('/aq/accountCenter')">{{ $t('components.header.accountCenter')
						}}</span>
						&nbsp;
						<span>
							<!-- <pp-icon type="arrow-down-b" /> -->
							<i class="el-icon-arrow-down el-icon--right" />
						</span>

						<ul v-if="showlist" :class="{'down-list':true,'en-width':locales==='en'}">
							<li @click="jump('/aq/accountCenter')">
								<i class="iconfont">&#xe630;</i>
								{{ $t('components.header.accountCenter') }}
							</li>
							<li v-if="asyncMenuControl('M-0802')" @click="goKyc">
								<i class="iconfont" style="font-size:17px;">&#xe631;</i>
								{{ $t('components.header.identityVerification') }}
							</li>
							<li v-if="asyncMenuControl('M-13')" @click="jump('/aq/offlineKyc')">
								<i class="iconfont" style="font-size:17px;">&#xe631;</i>
								{{ $t('components.header.identityVerification') }}
							</li>
							<li v-if="asyncMenuControl('M-0803')" @click="jump('/aq/cashAccount')">
								<i class="iconfont" style="font-size:16px;">&#xe62e;</i>
								<i>{{ $t('components.header.withdrawCenter') }}</i>
							</li>
							<li v-if="currentsAccountRelated && asyncMenuControl('M-0807')" @click="currentsLinkClick">
								<i class="iconfont" style="font-size:20px;">&#xe6a1;</i>
								<i>{{ $t('components.header.currentsCollection') }}</i>
							</li>
							<li v-if="asyncMenuControl('M-0805')" @click="jump('/aq/messageReceiverSetting')">
								<i class="iconfont" style="font-size:16px;">&#xe639;</i>
								<i>{{ $t('components.header.emailMsg') }}</i>
							</li>
							<li v-if="vaAccountRelated" @click="pingpongLinkClick">
								<i class="iconfont" style="font-size:20px;">&#xe6a1;</i>
								<i>{{ $t('components.header.pingpongCollection') }}</i>
							</li>

							<li @click="logOut">
								<i class="iconfont">&#xe66e;</i>
								{{ $t('components.header.logOut') }}
							</li>
						</ul>
					</span>
				</div>
			</div>
			<div class="menu">
				<el-menu mode="horizontal" theme="light" :default-active="onRoutes" unique-opened router>
					<!-- 首页 -->
					<el-menu-item index="/aq/homePage">{{ $t('components.header.homepage') }}</el-menu-item>
					<!-- 网站管理 -->
					<el-submenu v-if="asyncMenuControl('M-02')" index="1">
						<template slot="title">{{ isFromOmnichannel ? $t("components.header.omniWebsiteManage"): $t('components.header.websiteManage') }}</template>
						<el-menu-item v-if="asyncMenuControl('M-14')" index="/aq/storeManage">
							{{ $t('components.header.storeManage') }}</el-menu-item>
						<!-- 网站管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0202')" index="/aq/websiteList">
							{{ isFromOmnichannel ? $t('components.header.omniWebsiteManageReview') :$t('components.header.websiteManageReview') }}
						</el-menu-item>

						<!-- 群组管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0201')" index="/aq/groupManage">
							{{ isFromOmnichannel ? $t('components.header.omniGroupManagement') : $t('components.header.groupManagement') }}</el-menu-item>

						<!-- 店铺进件查询 -->
						<el-menu-item v-if="asyncMenuControl('M-0203')" index="/aq/storeOnboarding">{{
							$t('components.header.storeOnboarding') }}</el-menu-item>
					</el-submenu>

					<!-- 门店管理 -->
					<!-- <el-menu-item v-if="asyncMenuControl('M-14')" index="/aq/storeManage">{{
						$t('components.header.storeManage') }}</el-menu-item> -->

					<!-- 交易管理 -->
					<el-submenu v-if="asyncMenuControl('M-10')" index="9">
						<template slot="title">{{ $t('components.header.transaction') }}</template>
						<!-- 交易查询 -->
						<el-menu-item v-if="asyncMenuControl('M-1001')" index="/aq/transitionLog">{{
							$t('components.header.transitionLog') }}</el-menu-item>
						<!-- 退款查询 -->
						<el-menu-item v-if="asyncMenuControl('M-1002')" index="/aq/refundLog">{{
							$t('components.header.refundLog') }}</el-menu-item>
					</el-submenu>

					<!-- 资金管理 -->
					<el-submenu v-if="asyncMenuControl('M-03')" index="2">
						<template slot="title">{{ $t('components.header.fundManagement') }}</template>
						<!-- 账户余额 （新增）-->
						<el-menu-item v-if="asyncMenuControl('M-0301')" index="/aq/accountBalance">{{
							$t('components.header.accountBalance') }}</el-menu-item>
						<!-- 提现明细 -->
						<el-menu-item v-if="asyncMenuControl('M-0302')" index="/aq/withdrawalDetail">{{
							$t('components.header.withdrawalDetail') }}</el-menu-item>
						<!-- 待结算交易统计Unsettled Balance -->
						<el-menu-item v-if="asyncMenuControl('M-0303')" index="/aq/unsettledBalance">{{
							$t('components.header.unsettledBalance') }}</el-menu-item>
					</el-submenu>
					<!-- 风险管理 -->
					<el-submenu v-if="asyncMenuControl('M-04')" index="3">
						<template slot="title">{{ $t('components.header.riskManagement') }}</template>
						<!-- 调单拒付管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0401')" index="/aq/chargeback">{{
							$t('components.header.chargebackManagement') }}</el-menu-item>
						<!-- 风险订单管理 (新增）-->
						<el-menu-item v-if="asyncMenuControl('M-0402')" index="/aq/riskTransactionManagement">{{
							$t('components.header.riskTransactionManagement') }}</el-menu-item>
						<!-- 黑名单管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0403')" index="/aq/blacklist">{{
							$t('components.header.blacklist') }}</el-menu-item>
						<!-- 白名单管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0404')" index="/aq/whiteList">{{
							$t('components.header.whitelist') }}</el-menu-item>
						<!-- 争议订单管理 -->
						<el-menu-item v-if="asyncMenuControl('M-0407')" index="/aq/disputeManage">{{
							$t('components.header.disputeManage') }}</el-menu-item>
					</el-submenu>
					<!-- 支付链 -->
					<el-submenu v-if="asyncMenuControl('M-09')" index="5">
						<template slot="title">{{ $t('components.header.paymentLink') }}</template>
						<!-- 支付链 （新增）-->
						<el-menu-item v-if="asyncMenuControl('M-0901')" index="/aq/paymentLink">{{
							$t('components.header.paymentLink') }}</el-menu-item>
						<template v-if="payLinkIsOldPage">
							<!-- 品牌信息维护 -->
							<el-menu-item v-if="asyncMenuControl('M-0902')" index="/aq/brandList">{{
								$t('components.header.brandList') }}</el-menu-item>
							<!-- 支付链模版管理 -->
							<el-menu-item v-if="asyncMenuControl('M-0903')" index="/aq/paymentLinkTemplateList">{{
								$t('components.header.templateManage') }}</el-menu-item>
						</template>
						<template v-else>
							<!-- 支付链主题管理 -->
							<el-menu-item v-if="asyncMenuControl('M-0905')" index="/aq/paymentLinkThemeList">{{
								$t('components.header.themeManage') }}</el-menu-item>
							<!-- 支付链模式管理 -->
							<el-menu-item v-if="asyncMenuControl('M-0906')" index="/aq/paymentLinkModeList">{{
								$t('components.header.modeManage') }}</el-menu-item>
						</template>
					</el-submenu>
					<!-- 物流管理 -->
					<el-menu-item v-if="asyncMenuControl('M-05')" index="/aq/logisticsManage">
						{{ $t('components.header.logisticsManage') }}
						<span v-if="newIcon==='Y'" class="new-icon">New</span>
					</el-menu-item>
					<!-- 报表管理 -->
					<el-submenu v-if="asyncMenuControl('M-06')" index="4">
						<template slot="title">{{ $t('components.header.statement') }}</template>
						<!-- 结算报表 -->
						<!-- <el-menu-item
							:class=" locales=== 'en'? 'mgt2' : '' "
							index="/aq/settlement"
							v-if="asyncMenuControl('M-0601')"
						>{{$t('components.header.settlementStatement')}}</el-menu-item> -->
						<!-- 月发票 -->
						<el-menu-item v-if="asyncMenuControl('M-0604')" index="/aq/invoice">Invoice</el-menu-item>
						<!-- 商户对账单 -->
						<el-menu-item v-if="asyncMenuControl('M-0605')" index="/aq/statementDownload">{{
							$t('components.header.statementDownload') }}</el-menu-item>
						<!-- 交易分析-->
						<el-menu-item v-if="asyncMenuControl('M-0602')" index="/aq/dataReport">{{
							$t('components.header.transactionAnalysis') }}</el-menu-item>
					</el-submenu>
					<!-- 系统设置 -->
					<el-submenu v-if="asyncMenuControl('M-07')" index="7">
						<template slot="title">{{ $t('components.header.system') }}</template>
						<el-menu-item v-if="asyncMenuControl('M-0701')" index="/aq/system">{{
							$t('components.header.permission') }}</el-menu-item>
						<el-menu-item v-if="asyncMenuControl('M-0702')" index="/aq/keySetting">{{
							$t('components.header.keySetting') }}</el-menu-item>
					</el-submenu>
					<!-- <el-menu-item index="/aq/system" v-if="asyncMenuControl('M-08')">{{$t('components.header.system')}}</el-menu-item> -->
				</el-menu>
			</div>
		</div>
	</header>
</template>

<script>
import { getUnreadMessageCount } from '@/api/modules/messageCenter'
import { getMetaToken } from '@/api/modules/accountCenter'
import { createNamespacedHelpers } from 'vuex'
import lang from './lang'
import timeZone from './timeZone.vue'
const {
	mapGetters: userMapGetters,
	mapActions: userMapActions
} = createNamespacedHelpers('user')

const {
	mapGetters: routeMapGetters,
	mapActions: routeMapActions
} = createNamespacedHelpers('route')

export default {
	name: 'PpHeader',
	computed: {
		...userMapGetters(['logoutInfo', 'newIcon', 'accountCenterInfo']),
		...routeMapGetters(['pingpongLink', 'currentsLink', 'paymentLinkPermission', 'vaAccountRelated', 'currentsAccountRelated']),
		onRoutes() {
			return this.$route.path
		},
		// 菜单权限控制
		asyncMenuControl() {
			return function(menuCode) {
				return this.$store.state.permission.asyncMenu.includes(
					menuCode
				)
			}
		}
	},
	components: {
		lang,
		timeZone
	},
	data() {
		return {
			listTimeout: null,
			showlist: false,
			show: true,
			activeName: 'webManagement',
			link: 'https://www.pingpongx.com',
			locales: this.$i18n.locale,
			noReadMessageCount: 0,
			isFromOmnichannel: this.$store.state.user.isFromOmnichannel
		}
	},
	created() {
		const urlname = window.location.pathname
		if (urlname === '/aq/accountCenter') {
			this.activeName = ''
		}
		this.activeName = this.$route.name
		if (this.activeName == 'checkStatus') {
			this.show = false
		}

		getUnreadMessageCount().then(res => {
			const { noReadCount } = res
			this.noReadMessageCount = noReadCount
		})
	},
	methods: {
		...userMapActions(['getLogoutInfo']),
		...routeMapActions(['autoLoginAddress', 'autoLoginCurrentsAddress']),

		async currentsLinkClick() {
			await this.autoLoginCurrentsAddress()
			if (this.currentsLink) {
				this.jump(this.currentsLink)
			}
		},
		async goKyc() {
	 // US 用户走中台KYC管理
	 if (this.accountCenterInfo.isMetaClient) {
				const res = await getMetaToken()
		 // window.location.href = `${process.env.VUE_APP_KYC}?lang=${localStorage.getItem('lang')}&authorization=${res.metaToken}`
				// window.location.href = `http://localhost:9016?lang=${localStorage.getItem('lang')}&authorization=${res.metaToken}`
				window.open(`${process.env.VUE_APP_KYC}?lang=${localStorage.getItem('lang')}&authorization=${res.metaToken}`, '_blank')
			} else {
      	 this.jump('/aq/certification')
			}
		},
		async pingpongLinkClick() {
			await this.autoLoginAddress()
			if (this.pingpongLink) {
				this.jump(this.pingpongLink)
			}
		},
		mouseoverFunc() {
			if (typeof this.listTimeout === 'number') {
				clearTimeout(this.listTimeout)
			}

			this.showlist = true
		},
		mouseoutFunc() {
			this.listTimeout = setTimeout(() => {
				this.showlist = false
			}, 600)
		},
		// 退出登录
		async logOut() {
			// 用户登出
			// 清空路由
			this.$store.dispatch('routerLogout')
			this.$store.dispatch('user/logout')
			await this.getLogoutInfo()
	  console.error(this.logoutInfo)
			if (this.logoutInfo === '提交成功' || this.logoutInfo === 'SUCCESS') {
				sessionStorage.removeItem('accessToken')
				localStorage.removeItem('isAlert')
				this.$jump({ path: '/aq/login' })
			} else {
				this.$message.error(this.$t('components.header.logoutFailed')) // "登出失败，请稍后再试");
			}
		},

		jump(url) {
			window.location.href = url
		}
	}
}
</script>
<style lang="scss">
.pp-menu-horizontal.pp-menu-light:after {
	background-color: transparent;
}
</style>
<style lang="scss" scoped>
.container-lang {
	margin-right: 10px;
}
.header-wrap {
	background: #fff;
}
.header {
	background: #fff;
	width: 1190px;
	margin: 0 auto;
	position: relative;
	color: #666;
	padding: 12px 0 0px 0;
  .fl{
    float: left;
  }
}

.btn {
	position: absolute;
	bottom: 8px;
	right: 0;
	width: 116px;
}

.menu {
	background: #fff;
	margin-top: 38px;
	text-align: left;
	.mgt2 {
		margin-top: -2px;
	}
}

.pp-btn-spec {
	padding: 5px 0px;
}

.right {
	float: right;
	height: 40px;
	line-height: 40px;
	vertical-align: middle;
	z-index: 1000;
	.iconfont {
		font-size: 20px;
		position: relative;
		top: 1px;
		&.ft16 {
			font-size: 16px;
		}
	}
  .iconfont-new {
    font-size: 20px;
    vertical-align: -2px;
  }
  .text {
    font-size: 14px;
  }
  .notify {
    cursor: pointer;
    position: relative;
    margin-left: 12px;
    margin-right: 20px;
    .notification-dot {
      position: absolute;
      top: -4px;
      left: 18px;
      width: 5px;
      height: 5px;
      background-color: #ff4d4f;
      border-radius: 50%;
    }
  }
	.account {
		cursor: pointer;
		position: relative;
		ul {
			z-index: 999;
			background: #fff;
			top: 40px;
			padding: 0 16px;
			right: 0px;
			position: absolute;
			z-index: 1000;
			// width: 253px;
			box-shadow: 0 1px 5px 0 rgba(126, 126, 126, 0.1),
				0 3px 4px 0 rgba(126, 126, 126, 0.06),
				0 0 4px 0 rgba(126, 126, 126, 0.07);
			text-align: right;
			li {
				border-bottom: 1px solid #f0f6fa;
				padding: 10px 0;
				display: flex;
				align-items: center;
				i {
					margin-right: 15px;
					line-height: 40px;
				}
			}
			li:hover {
				color: #1fa0e8;
			}
		}
		::v-deep .down-list {
			width: 180px;
			text-align: right;
			z-index: 1000;
			i {
				font-style: normal;
			}
		}
		.en-width{
			width: 253px;
		}
	}
	.help {
		margin-right: 26px;
		cursor: pointer;
	}
	.i-text {
		font-size: 14px;
		font-style: normal;
		position: relative;
		top: 2px;
		font-weight: normal;
	}

	.icon-id1 {
		font-size: 15px;
	}
}
.new-icon {
	background: #ff4949;
	border-radius: 8px;
	font-size: 12px;
	color: #ffffff;
	padding: 0px 6px;
}
.menu ::v-deep .el-menu.el-menu--horizontal {
	border-color: transparent;
}
</style>
